import React, { useState } from "react";
import styles from "../../styles/pages/createemptwin.module.scss";
import Icons from "../../public/assets/svg";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import {useRouter} from "next/router";
import _get from "lodash/get";
//import UploadDocuments from "../uploadDocuments";
import UploadFileComponent from "../uploadFileemptwin";
import _ from "lodash";
import endpoint from "../../utility/endpoints.js";
import axios from "axios";
import Loader from "../Loader";
import Dropdown from "../listWithoutcheck";
//import BasicForm from "../basicemptwinForm";
import BasicForm from "../basicemptwinForm1";
import SoftSkillModal from "../Pages/SoftSkill";
import SuccessModal from "../../pages/successModal";
import endpoints from "../../utility/endpoints.js";
import {
  sessionTimeOutCheck,
  checkExpiry,
} from "../../redux/global/actions.js";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { BlobServiceClient } from "@azure/storage-blob";
import CheckboxDropdown from "../listDropdown";
import DropDown from "../listWithoutcheck";
//multiple document			
import UploadDoc from "../DocumentETUploader";  
function index(props) {
  const router = useRouter()
  let emptwinForm = props.data;
 // console.log("edit page data",emptwinForm);
  const empid = JSON.parse(localStorage.getItem('empid'))
  
  //console.log(empid)
  let dropDownsInitialStates = {};
  /*lead platform, area, subarea code*/
 
  const leadPlatformData = props.globalData.lead_platform_main_component[0];
  const areaData = props.globalData.lead_platform_main_component[1];
  const subAreaData = props.globalData.lead_platform_main_component[2];
  
  const clusterData = props.globalData.cluster_main_component[0];
  const mcoData = props.globalData.cluster_main_component[1];
  const countryData = props.globalData.cluster_main_component[2];

  const [filterDropdowns,setFiltersDropdowns] = useState([ 
    props.globalData.lead_platform_main_component[0],
    props.globalData.lead_platform_main_component[1],
    props.globalData.lead_platform_main_component[2],
    props.globalData.cluster_main_component[0],
    props.globalData.cluster_main_component[1],
    props.globalData.cluster_main_component[2]
  ]);
  
  
  /*end lead platform, area, subarea code*/

 // console.log("Emptwin form data  ----", emptwinForm);
 
 

  const [fileError, setError] = useState(false);

  const [file, setFile] = useState(null);
  const [file1, setFile1] = useState(null);
  const [fileNameOriginal, setFileName] = useState(null);
  const [fileNameOriginal1, setFileName1] = useState(null);
  const [showFileName, setShowFileName] = useState(false);
  const [showFileName1, setShowFileName1] = useState(false);
  const [automationPdfs, setAutomationPdfs] = useState([]);
  const [confidentialPdfs, setConfidentialPdfs] = useState([]);

  const [logoFile, setLogoFile] = useState(null);
  const [fileerror, setFileError] = useState(false);
  const [filesuccess, setFilesuccess] = useState(false);
  // const [imageName,setImageName]=useState(null)

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    //setLogoFile(file.name);
    uploadFiles(file);
  };
  console.log("logofile", logoFile);

  const uploadFiles = async (imageFile) => {
    const originalFileName = imageFile.name;
    let fileName = originalFileName;
    setLogoFile(
      "https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/emp/" +
        fileName
    );
    let index = 1;
    while (await containerClient.getBlockBlobClient(fileName).exists()) {
      const extension = originalFileName.substring(
        originalFileName.lastIndexOf(".")
      );
      fileName = `${originalFileName.substring(
        0,
        originalFileName.lastIndexOf(".")
      )}_${index}${extension}`;
      index++;
    }
    const blockBlobClient = containerClient.getBlockBlobClient(fileName);
    try {
      await blockBlobClient.uploadBrowserData(imageFile);
      console.log("Image uploaded successfully!");
      setLogoFile(
        "https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/emp/" +
          fileName
      );
      setFilesuccess(true);
    } catch (error) {
      setFileError(true);
      console.error("Error uploading image:", error);
    }
  };
  
  const [filenameError, setFileNameError] = useState(false);
  
  const [fileTypes, setfileTypes] = useState([
    "pdf",
    "docx",
    "doc",
    "xlsx",
    "ppt",
    "pptx",
    "mp4"
  ]);
  const [fileTypesp, setfileTypesp] = useState([
   "jpg",
   "jpeg",
   "png",
  ]);
 
  const [auth, setAuth] = useState({});
  let initialStates = {};

  const initialState = {
    "newRequest": "new",
    "employeeTwinID": '',
    "employeeTwinName": "",
    "securityGroupId": "",
    "employeeTwinDescription": "",
    "status": "",
    "leadPlatform": "",
    "area": "",
    "subArea": "",
    "cluster": "",
    "mco": "",
    "geoItPartner": "",
    "country": "",
    "businessOwner": "",
    "engagementLead": "",
    "globalSkill": "",
    "localSkill": "",
    "softSkill": "",
    "manualhour":"",
    "fte":"",
    "businessRequest":"",
    "uploadPhoto": "",
    "uploadDocument": "",
    "businessgroup":"",
    "businessunit":"",
    "businessoption":"",
    "goLiveDate":"",
    "product_id":"",
    	   "sopDocument":"",			
    "pddDocument":"",			
    "pddApprovalDocument":"",			
    "sddDocument":"",			
    "qsgDocument":"",			
    "odiDocument":"",			
    "brdDocument":"",			
    "costApprovalDocument":"",			
    "explicitLandscapeApplicationOwnerApprovalDocument":"",			
    "explicitGPMApprovalSupplyChainFinanceDocument": "",			
    "explicitGFCFApprovalDocument": "",			
    "devQualityCredentialsAvailableDocument": "",			
    "infosecApprovalDocument": "",			
    "dAReviewSignOffDocument": "",			
    "testDataAvailableForDevelopmentDocument": "",			
    "requestRaisedForProductionCredentialsDocument": "",			
    "internalTestingCompletedDocument": "",			
    "peerReviewSignOffDocument": "",			
    "daReviewSecondSignOffDocument": "",			
    "bpReleaseSignOffFromDaDocument": "",			
    "uatScriptsWithResultsDocument": "",			
    "uatSignOffDocument": "",			
    "releaseManagerSignOffDocument": "",			
    "gateFormDocument": "",			
    "peerReviewchecklistDocument": "",			
    "qaSignOffDocument": "",			
    "walkthroughVideo": "",			
    "ktVideo": "",
    "transactions":"",
    "reporting":"",
    "cognitive":"",
    "decisionautomations":"",
    "genAi": "",
  };
  const initialState1 = {
    "newRequest": "new",
    "employeeTwinName": "",
    "securityGroupId": "",
    "employeeTwinDescription": "",
    "uploadPhoto": "",
    "status": "",
    "geoItPartner": "",
    "businessOwner": "",
    "engagementLead": "",
    "manualhour":"",
    "fte":"",
    "uploadDocument": "",
    "businessgroup":"",
    "businessunit":"",
    "businessoption":"",
    "product_id":"",
    	   "sopDocument":"",			
    "pddDocument":"",			
    "pddApprovalDocument":"",			
    "sddDocument":"",			
    "qsgDocument":"",			
    "odiDocument":"",			
    "brdDocument":"",			
    "costApprovalDocument":"",			
    "explicitLandscapeApplicationOwnerApprovalDocument":"",			
    "explicitGPMApprovalSupplyChainFinanceDocument": "",			
    "explicitGFCFApprovalDocument": "",			
    "devQualityCredentialsAvailableDocument": "",			
    "infosecApprovalDocument": "",			
    "dAReviewSignOffDocument": "",			
    "testDataAvailableForDevelopmentDocument": "",			
    "requestRaisedForProductionCredentialsDocument": "",			
    "internalTestingCompletedDocument": "",			
    "peerReviewSignOffDocument": "",			
    "daReviewSecondSignOffDocument": "",			
    "bpReleaseSignOffFromDaDocument": "",			
    "uatScriptsWithResultsDocument": "",			
    "uatSignOffDocument": "",			
    "releaseManagerSignOffDocument": "",			
    "gateFormDocument": "",			
    "peerReviewchecklistDocument": "",			
    "qaSignOffDocument": "",			
    "walkthroughVideo": "",			
    "ktVideo": "",
  };
		
 const [sopInvalid, setSopInvalid] = React.useState(false); 				
  //multiple document			
  const [modalShow, setModalShow] = React.useState(false);			
  const [uploadedDocumentsState, setUploadedDocumentsState] = React.useState(null);		
    const [uploadedFileToShow, setUploadedFileToShow] = React.useState(null);		
  const [totalUploadedItems, setTotalUploadedItems] = React.useState(null);

  const [emptwin, setEmptwin] = React.useState(initialState);
  const [emptwin1, setEmptwin1] = React.useState(initialState1);
  const [childData, setChildData] = useState('');
  const [emailCheck, setEmailCheck] = React.useState([]);
  const [requiredFields, setRequiredFields] = React.useState([]);
  const [numberCheck, setNumberCheck] = React.useState([]);
  const [invalidFlag, setInvalidFlag] = React.useState(false);
  const [successModal, setSuccessModal] = React.useState(false);
  const [successModal1, setSuccessModal1] = React.useState(false);
   const [successModal2, setSuccessModal2] = React.useState(false);  
const [sucessOrFailure, setsucessOrFailure] = React.useState(false);
  const [getFormValues, setGetFormValues] = React.useState(false);
  const [message, setMessage] = React.useState(
    "We added soft skill"
  );
  /*Upload file code */
  


  const [submitForm, setSubmitForm] = React.useState(false);
    //for transactional and global skill
  const [globalskills,setGlobalskills]=useState([]);
  const [globalvalue,setGlobalvalue]=useState([]);
  const [checked, setChecked] = React.useState(false);
  //for reporting and local skill
  const [localskills,setLocalskills]=useState([]);
  const [localvalue,setLocalvalue]=useState([]);
  const [checkedL, setCheckedL] = React.useState(false);
  //for cognitive skill
  const [cognitiveskills,setCognitiveskills]=useState([]);
  const [cognitivevalue,setCognitivevalue]=useState([]);
  const [checkedC, setCheckedC] = React.useState(false);

 //for decisionautomations skill

  const [decisionautomationsskills,setDecisionautomationsskills]=useState([]);
  const [decisionautomationsvalue,setDecisionautomationsvalue]=useState([]);
  const [checkedD, setCheckedD] = React.useState(false);

  // for genAI Skills
  const [genAISkills, setGenAISkills] = useState([]);
  const [genAIvalue, setGenAIvalue] = useState([]);
  const [checkedG, setCheckedG] = React.useState(false);

  //for gen AI skills search
  const [inputValueg, setInputValueg] = useState("");

  const [inputValue, setInputValue] = useState('');
  const [inputValue1, setInputValue1] = useState('');
  //for cognitive skill search
  const [inputValuec, setInputValuec] = useState('');
//for decisionautomation skill search
  const [inputValued, setInputValued] = useState('');


  const [skillvalue,setSkillvalue]=useState([]);
  const [checkedS, setCheckedS] = React.useState(false);
  const [products, setProducts] = useState([]);	
  const [productids, setProductids] = useState([]);	
  const [productvalue,setProductvalue]=useState([]);	
  const [checkedP, setCheckedP] = React.useState(false);
let items;
  let sid;
const checkedSoft = (e) => {
sid=e.target.value;

if(items.includes(sid))
  {
      
  }
else
{
  items.push(sid);
  localStorage.setItem('myData', JSON.stringify(items));
}
setCheckedS(false);
};
  items = JSON.parse(localStorage.getItem('myData')) || [];
//  const items = JSON.parse(localStorage.getItem('myData')) || [];
/*Dropdown Added by Anshu*/
const [reset, setreset] = useState(false);
const [leadPlatform,setLeadPlatform]=React.useState('');
const [area,setArea]=React.useState('');
const [subArea,setSubArea]=React.useState('');
const [cluster,setCluster]=React.useState('');
const [mco,setMco]=React.useState('');
const [country,setCuntry]=React.useState('');

/*code for dropdown select*/
const [selectedOptions, setSelectedOptions] = useState([]);
const [toggle,setToggle]=useState(false)
const [selectedcountryOptions, setSelectedcountryOptions] = useState([]);
const [togglen,setTogglen]=useState(false);
const [loader, setloader] = useState(false);

const handleSelect = (e) => {
  const value = e.target.value;
  setEmptwin({
    ...emptwin,
    [e.target.id]: value,
  });

  if (selectedOptions.includes(value)) {
    setSelectedOptions(selectedOptions.filter((option) => option !== value));
  } else {
    setSelectedOptions([...selectedOptions, value]);
    
  }

};
const handleSelectcountry = (e) => {
  const value = e.target.value;
  setEmptwin({
    ...emptwin,
    [e.target.id]: value,
  });
  if (selectedcountryOptions.includes(value)) {
    setSelectedcountryOptions(selectedcountryOptions.filter((option) => option !== value));
  } else {
    setSelectedcountryOptions([...selectedcountryOptions, value]);
  }

};
//console.log("country selected value",selectedcountryOptions);
const GetData = (recive) => {
  // function code here
 // console.log("recive" , recive.leadPlatform)
  setLeadPlatform(recive.leadPlatform);
  setArea(recive.area);
  setSubArea(recive.subArea);
  setCluster(recive.cluster);
  setMco(recive.mco);
  setCuntry(recive.country);
  
};

const onToggle=()=>{
  setToggle(true);
}
const onTogglen=()=>{
  setTogglen(true);
}
const onValueChange = async (e) => {
  const value = e.target.value;
  if(e.target.id=="cluster"){
    setSelectedOptions([]);
    setSelectedcountryOptions([]);
  }
  setEmptwin({
    ...emptwin,
    [e.target.id]: value,
  });
  setEmptwin1({
    ...emptwin1,
    [e.target.id]: value,
  });
}
  // if (e.target.value) {
  //   setStateError({ ...stateError, [e.target.id]: "valid" });
  // } 
  // else {
  //   setStateError({ ...stateError, [e.target.id]: true });
  // }

 //multiple document			
const gotDocInfo = (name, url, title, uploadedItems, extension) => {			
  let ar = url.split("?");			
  let another = ar[0].split("/");			
  let toSend = another[another.length - 1];			
  // console.log(title, uploadedItems, "uploaded data of data");			
  // console.log(name, "nameat uploaderrr", title)			
  console.log(extension, "extension at 56")			
//  setUploadedFileToShow(title);			
  setTotalUploadedItems(uploadedItems);			
  sendDocInfo(name, toSend, extension);			
};	
const sendAllInfoAboutUploadModal = (			
  uploaded,			
  totalItems,			
  uploadedItems,			
  originalFileNames,			
  azureFileNames,			
  deleteDocumentsLater,			
  presentState			
) => {			
  if (uploaded.sopDocument) {			
    setSopInvalid(false)			
  }			
  else {			
    setSopInvalid(true)			
  }			
  console.log("sab console kara lo",  uploaded,"1",			
  totalItems,"22",			
  uploadedItems, "33",			
  originalFileNames,"44",			
  azureFileNames,"555",			
  deleteDocumentsLater,"6666",			
  presentState)			
 			
 //setUploadedFileToShow(documentAr.filter((item) => item.value === Object.keys(presentState)[Object.keys(presentState).length-1])[0].title)			
 console.log(azureFileNames, "azurefiles234latest")			
 console.log(uploadedDocumentsState, "azurefiles234previous")			
 let deleteDocumentsLaterToSet = []			
 if (uploadedDocumentsState && uploadedDocumentsState.deleteDocumentsLater && uploadedDocumentsState.deleteDocumentsLater.length>0){			
   deleteDocumentsLaterToSet = [...uploadedDocumentsState.deleteDocumentsLater]			
   for (let i in uploadedDocumentsState.azureFileNames) {			
    if (!(i in azureFileNames)){			
      deleteDocumentsLaterToSet.push(uploadedDocumentsState.azureFileNames[i])			
    }			
  }			
 }			
  setUploadedDocumentsState({			
    uploaded,			
    totalItems,			
    uploadedItems,			
    originalFileNames,			
    azureFileNames : {...azureFileNames},			
    deleteDocumentsLater : [...deleteDocumentsLaterToSet],			
  });			
  setTotalUploadedItems(uploadedItems)			
  			
};			
const openDocumentModal = () => {			
  let modal = !modalShow;			
  setModalShow(true);			
  if (modal === true) {			
    document.body.style.overflow = "hidden";			
  } else {			
    document.body.style.overflow = "unset";			
  }			
};			
const closeDocumentModal = () => {			
  let modal = !modalShow;			
  setModalShow(false);			
  if (modal === true) {			
    document.body.style.overflow = "hidden";			
  } else {			
    document.body.style.overflow = "unset";			
  }			
};		


  let azurefilepath;
  const blobSasUrl =
  "https://newbotstore.blob.core.windows.net/?sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2021-04-02T10:26:05Z&st=2021-03-02T02:26:05Z&spr=https&sig=v7MtaG5GbZX7NyzUpshCkd61ouluKHob5uram7ip9eM%3D";

const blobSasUrlNew = endpoints.blobSasUrlNew;
// "https://newbotstore.blob.core.windows.net/?sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2022-04-03T15:11:13Z&st=2021-04-03T07:11:13Z&spr=https&sig=yJGmi7uHf8DAG%2BfT%2FOsKBLFP3URycUiPaPRocqIqSh8%3D";
const blobServiceClient = new BlobServiceClient(blobSasUrlNew);

const containerClient = blobServiceClient.getContainerClient("botstorevideo/employeetwin/emp");

  const uploadFile = (file, name) => {
   
    azurefilepath= "https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/emp/"+file.name;
    //console.log("azure file path",azurefilepath)
    //console.log(automationPdfs, "pdfsauto");
    if (
      automationPdfs.filter((item, index) => item.docUrl == file.name).length >
        0 ||
      confidentialPdfs.filter((item, index) => item.docUrl == file.name)
        .length > 0
    ) {
      setFileNameError(true);
      //setSuccessModal(true);
      return;
    }

    setFile(file);
    setShowFileName(true);
    setFileName(file.name);
  };

  const uploadButtonClick = async () => {
    //console.log(fileNameOriginal, "fileName", file);

    let fileNameWithSpaces = fileNameOriginal;
    let fileName = fileNameWithSpaces.replace(/ /g, " ");
    let ar = fileNameOriginal.split(".");
    let extension = ar[ar.length - 1];
    const fileSize = file.size;

    try {
      const blockBlobClient = containerClient.getBlockBlobClient(fileName);
      const options = { blobHTTPHeaders: { blobContentType: file.type } };
      const resp = await blockBlobClient.uploadBrowserData(file, options);
      //console.log(resp, "response of azure");
      let url = resp._response.request.url;

      let ar = url.split("?");
      let another = ar[0].split("/");
      let toSend = another[another.length - 1];

      let authCheck = JSON.parse(localStorage.getItem("auth")).data;
      let expiryStatus = await props.checkExpiry(authCheck);
      if (expiryStatus) {
        let auth = JSON.parse(localStorage.getItem("auth")).data;
        axios({
          method: "post",
          url: `${endpoints.baseUrl}/framework/createFramework`,
          data: {
            docType: extension,
            docName: fileNameOriginal,
            docCategory: "png",
            docUrl: toSend,
            docSize: fileSize,
          },
          headers: {
            Authorization: `${auth.accessToken}|${auth.email}`,
          },
        }).then((resp) => {
          if (resp.data.code == 200) {
            //  console.log(resp);
        //    window.scrollTo(0, 0);
          //  setSuccessModal(true);
          //setShowFileName(false);
            //setFile(null);
            setError(false);
          //  setFileName(null);
            //getAllPdfs();
                      setSuccessModal2(true);
 setTimeout(() => {
        setSuccessModal2(false)

      }, 1000);

          } else if (resp.data.code == 403) {
            localStorage.removeItem("auth");
            sessionStorage.clear();
            props.sessionTimeOutCheck(true);
          }
        });
      } else {
        props.sessionTimeOutCheck(true);
      }
    } catch (error) {
      //console.log(error, "erro");
      alert("Could not upload");
    }
  };


  const uploadFile1 = (file, name) => {
    //console.log(file.name, "pdfsauto");
    azurefilepath= "https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/emp/"+file.name;
    //console.log("azure file path",azurefilepath)
    //console.log(automationPdfs, "pdfsauto");
    if (
      automationPdfs.filter((item, index) => item.docUrl == file.name).length >
        0 ||
      confidentialPdfs.filter((item, index) => item.docUrl == file.name)
        .length > 0
    ) {
      setFileNameError(true);
     // setSuccessModal(true);
      return;
    }

    setFile1(file);
    setShowFileName1(true);
    setFileName1(file.name);
  };
  const uploadButtonClick1 = async () => {
    //console.log(fileNameOriginal, "fileName", file);

    let fileNameWithSpaces = fileNameOriginal1;
    let fileName = fileNameWithSpaces.replace(/ /g, " ");
    let ar = fileNameOriginal1.split(".");
    let extension = ar[ar.length - 1];
    const fileSize = file1.size;

    try {
      const blockBlobClient = containerClient.getBlockBlobClient(fileName);
      const options = { blobHTTPHeaders: { blobContentType: file1.type } };
      const resp = await blockBlobClient.uploadBrowserData(file1, options);
      //console.log(resp, "response of azure");
      let url = resp._response.request.url;

      let ar = url.split("?");
      let another = ar[0].split("/");
      let toSend = another[another.length - 1];

      let authCheck = JSON.parse(localStorage.getItem("auth")).data;
      let expiryStatus = await props.checkExpiry(authCheck);
      if (expiryStatus) {
        let auth = JSON.parse(localStorage.getItem("auth")).data;
        axios({
          method: "post",
          url: `${endpoints.baseUrl}/framework/createFramework`,
          data: {
            docType: extension,
            docName: fileNameOriginal1,
            docCategory: "png",
            docUrl: toSend,
            docSize: fileSize,
          },
          headers: {
            Authorization: `${auth.accessToken}|${auth.email}`,
          },
        }).then((resp) => {
          if (resp.data.code == 200) {
            //  console.log(resp);
       //     window.scrollTo(0, 0);
            setSuccessModal2(true);
 setTimeout(() => {
        setSuccessModal2(false)

      }, 1000);

         //   setShowFileName1(false);
            //setFile1(null);
            setError(false);
            //setFileName1(null);
            //getAllPdfs();
          } else if (resp.data.code == 403) {
            localStorage.removeItem("auth");
            sessionStorage.clear();
            props.sessionTimeOutCheck(true);
          }
        });
      } else {
        props.sessionTimeOutCheck(true);
      }
    } catch (error) {
      //console.log(error, "erro");
      alert("Could not upload");
    }
  };

  let myDate;
  const [godate,setGodate]=React.useState();
  const handleDate = (date, parent) => {

    if (typeof date == "object") {
      var bigDate = date._d;
      var dd = String(bigDate.getDate()).padStart(2, "0");
      var mm = String(bigDate.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = bigDate.getFullYear();
      const myDate = mm + "/" + dd + "/" + yyyy;
      //console.log("mydate",myDate);

      setState({ ...state, [parent]: myDate });
    } else {
      setState({ ...state, [parent]: date });
    }
    setGodate(date);
    //console.log("golivedate",date);
  };
  let inputprops = {
    placeholder: emptwin.goLiveDate,
  };
	   const [softdocument,setSoftdocument]=useState(false);
const submitemptwinForm = async () => {

  setSubmitForm(true);
  setGetFormValues(true);
  let authCheck = JSON.parse(localStorage.getItem("auth")).data;
  let expiryStatus = await props.checkExpiry(authCheck);
  //console.log("hello",authCheck);
  //console.log("hello",expiryStatus);

  //multiple Document			
  let softdocs=JSON.parse(localStorage.getItem("docURL1"));			
       if(!(localStorage.getItem("docURL1"))){			
        setSoftdocument(true);			
       }			
       if(localStorage.getItem("docURL1")){			
        setSoftdocument(false);			
       }			
        let sopDocument=softdocs?.sopDocument || emptwin.sopsopDocument;	
  let pddDocument=softdocs?.pddDocument || emptwin.pddDocument;	
  let pddApprovalDocument= softdocs?.pddApprovalDocument || emptwin.pddApprovalDocument;	
  let sddDocument= softdocs?.sddDocument || emptwin.sddDocument;	
  let qsgDocument= softdocs?.qsgDocument || emptwin.qsgDocument;	
  let odiDocument= softdocs?.odiDocument || emptwin.odiDocument;	
  let brdDocument= softdocs?.brdDocument || emptwin.brdDocument;	
  let costApprovalDocument= softdocs?.costApprovalDocument ||  emptwin.costApprovalDocument;	
  let explicitLandscapeApplicationOwnerApprovalDocument= softdocs?.explicitLandscapeApplicationOwnerApprovalDocument ||  emptwin.explicitLandscapeApplicationOwnerApprovalDocument;	
  let explicitGPMApprovalSupplyChainFinanceDocument= softdocs?.explicitGPMApprovalSupplyChainFinanceDocument ||  emptwin.explicitGPMApprovalSupplyChainFinanceDocument;	
  let explicitGFCFApprovalDocument= softdocs?.explicitGFCFApprovalDocument ||  emptwin.explicitGFCFApprovalDocument;	
  let devQualityCredentialsAvailableDocument= softdocs?.devQualityCredentialsAvailableDocument ||emptwin.devQualityCredentialsAvailableDocument;	
  let infosecApprovalDocument= softdocs?.infosecApprovalDocument || emptwin.infosecApprovalDocument;	
  let dAReviewSignOffDocument= softdocs?.dAReviewSignOffDocument || emptwin.dAReviewSignOffDocument;	
  let testDataAvailableForDevelopmentDocument= softdocs?.testDataAvailableForDevelopmentDocument || emptwin.testDataAvailableForDevelopmentDocument;	
  let requestRaisedForProductionCredentialsDocument= softdocs?.requestRaisedForProductionCredentialsDocument || emptwin.requestRaisedForProductionCredentialsDocument;	
  let internalTestingCompletedDocument= softdocs?.internalTestingCompletedDocument || emptwin.internalTestingCompletedDocument;	
  let peerReviewSignOffDocument= softdocs?.peerReviewSignOffDocument || emptwin.peerReviewSignOffDocument;	
  let daReviewSecondSignOffDocument= softdocs?.daReviewSecondSignOffDocument || emptwin.daReviewSecondSignOffDocument;	
  let bpReleaseSignOffFromDaDocument= softdocs?.bpReleaseSignOffFromDaDocument || emptwin.bpReleaseSignOffFromDaDocument;	
  let uatScriptsWithResultsDocument= softdocs?.uatScriptsWithResultsDocument || emptwin.uatScriptsWithResultsDocument;	
  let uatSignOffDocument= softdocs?.uatSignOffDocument || emptwin.uatSignOffDocument;	
  let releaseManagerSignOffDocument= softdocs?.releaseManagerSignOffDocument || emptwin.releaseManagerSignOffDocument;	
  let gateFormDocument= softdocs?.gateFormDocument ||emptwin.gateFormDocument;	
  let peerReviewchecklistDocument= softdocs?.peerReviewchecklistDocument || emptwin.peerReviewchecklistDocument;	
  let qaSignOffDocument= softdocs?.qaSignOffDocument || emptwin.qaSignOffDocument;	
  let walkthroughVideo= softdocs?.walkthroughVideo || emptwin.walkthroughVideo;	
  let ktVideo= softdocs?.ktVideo || emptwin.ktVideo;	

 let uploadPhoto;
let uploadDocument;

  if (logoFile !== null) {
      uploadPhoto = logoFile;
      console.log("not null");
    } else {
      uploadPhoto = emptwin.uploadPhoto;
      console.log("null", emptwin.uploadPhoto);
    }
  if (fileNameOriginal1 !== null) {
    uploadDocument="https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/emp/"+fileNameOriginal1
  }
  else{
    uploadDocument=emptwin.uploadDocument
  }
      if (expiryStatus) {
        let auth = await JSON.parse(localStorage.getItem("auth")).data;
        axios({
          method: "POST",
          url: `${endpoints.baseUrl}/twin/employeeTwin`,
          headers: {
            Authorization: `${auth.accessToken}|${auth.email}`,
          },
          data: {
            ...emptwin,
            // employeeTwinID:empid,
            globalSkill:globalvalue.join(','),
            localSkill:localvalue.join(','),
            transactions:globalvalue.join(','),
            reporting:localvalue.join(','),
            cognitive:cognitivevalue.join(','),
            decisionautomations:decisionautomationsvalue.join(','),
            genAi: genAIvalue.join(","),
            product_id:productvalue.join(','),
            softSkill:items.join(','),
            businessRequest:`${auth.email}`,
            mco:selectedOptions.join(','),
            country:selectedcountryOptions.join(','),
            //uploadPhoto:"https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/emp/"+fileNameOriginal,
           //uploadDocument:"https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/emp/"+fileNameOriginal1
           uploadPhoto:uploadPhoto,
           uploadDocument:uploadDocument,
           sopDocument:sopDocument,			
                pddDocument:pddDocument,			
                pddApprovalDocument: pddApprovalDocument,			
                sddDocument: sddDocument,			
                qsgDocument: qsgDocument,			
                odiDocument: odiDocument,			
                brdDocument: brdDocument,			
                costApprovalDocument: costApprovalDocument,			
                explicitLandscapeApplicationOwnerApprovalDocument: explicitLandscapeApplicationOwnerApprovalDocument,			
                explicitGPMApprovalSupplyChainFinanceDocument: explicitGPMApprovalSupplyChainFinanceDocument,			
                explicitGFCFApprovalDocument: explicitGFCFApprovalDocument,			
                devQualityCredentialsAvailableDocument: devQualityCredentialsAvailableDocument,			
                infosecApprovalDocument: infosecApprovalDocument,			
                dAReviewSignOffDocument: dAReviewSignOffDocument,			
                testDataAvailableForDevelopmentDocument: testDataAvailableForDevelopmentDocument,			
                requestRaisedForProductionCredentialsDocument: requestRaisedForProductionCredentialsDocument,			
                internalTestingCompletedDocument: internalTestingCompletedDocument,			
                peerReviewSignOffDocument: peerReviewSignOffDocument,			
                daReviewSecondSignOffDocument: daReviewSecondSignOffDocument,			
                bpReleaseSignOffFromDaDocument: bpReleaseSignOffFromDaDocument,			
                uatScriptsWithResultsDocument: uatScriptsWithResultsDocument,			
                uatSignOffDocument: uatSignOffDocument,			
                releaseManagerSignOffDocument: releaseManagerSignOffDocument,			
                gateFormDocument: gateFormDocument,			
                peerReviewchecklistDocument: peerReviewchecklistDocument,			
                qaSignOffDocument: qaSignOffDocument,			
                walkthroughVideo: walkthroughVideo,			
                ktVideo: ktVideo,
          },
        }).then((resp) => {
          //console.log(resp);
          if (resp.data.code == 403) {
            props.sessionTimeOutCheck(true);
            setState(initialState);
            setGetFormValues(false);
          } 
          else if (resp.status == 200) {
            // console.log(resp.data);
            //console.log("data from api---->",resp)
          
           // localStorage.removeItem('myData');
            //setItems(resp.data.data.softSkillID)
            
            localStorage.removeItem('docURL1');
            setState(initialState);
            setGetFormValues(false);
          } 
          else if (resp.data.code == 400) {
            setState(initialState);
            setGetFormValues(false);
          }
        });
      } else {
        props.sessionTimeOutCheck(true);
        
      }
      window.scrollTo(0, 0)
      setSuccessModal1(true);

      setTimeout(() => {
        setSuccessModal1(false)
      
      }, 2000);
      //setSuccessModal(true);
      //router.push("/Employeetwinskills");

};

const [emptyFormValues, setEmptyFormValues] = React.useState(false);

const [dropDownState1, setDropdownState1] = React.useState(
  dropDownsInitialStates
);
/*soft skill demo*/
const [softSkillModal, setsoftSkillModal] = React.useState(false);

const handleDropDown = (item) => {
  setDropdownState({
    ...dropDownsInitialStates,
    [item]: !dropDownState[item],
  });
};
// const gotDropDownValue = (value, dropdownParent) => {
//   setDropdownState(dropDownsInitialStates);
//   setState({ ...state, [dropdownParent]: value });



// };

const [dropDownState, setDropdownState] = React.useState({ status: false });
  
  const [leadState, setLeadState] = useState();
const inputChange = async (e) => {
  const value = e.target.value;
 setLeadState(e.target.value);

};
const inputHandler = async (e) => {
  const optionvalue = e.target.value;
  setInputValue1(optionvalue);
  //console.log(optionvalue);
 if (optionvalue.includes("P")) {	
    if (productvalue.includes(optionvalue)){	
    } 	
    else {	
      let auth = JSON.parse(localStorage.getItem("auth")).data;	
      const { data } = await axios({	
        url: `${endpoints.baseUrl}/twin/get_product?product_id=${optionvalue}`,	
        method: "GET",	
        headers: {	
          Authorization: `${auth.accessToken}|${auth.email}`,	
        },	
      });	
      console.log(data);	
      if (data.code === 200) {	
        setProductids(data.data);	
        setCheckedP(true);	
      } else {	
        console.log("No data found");	
      }	
    }	
  } 
 if(globalvalue.includes(optionvalue) || localvalue.includes(optionvalue)  || cognitivevalue.includes(optionvalue) ||decisionautomationsvalue.includes(optionvalue) || genAIvalue.includes(optionvalue))
  {

  }
  else
  {
    let auth = JSON.parse(localStorage.getItem("auth")).data;
    const { data } = await axios({
      url: `${endpoints.baseUrl}/botSearch/globalLocal?botID=${optionvalue}`,
      method: "GET",
      headers: {
        Authorization: `${auth.accessToken}|${auth.email}`,
      },

    });
   // console.log(data);
    if (data.code === 200) {
      setGlobalskills(data.data);
      setChecked(true);
      //console.log(data.data);
     // console.log("globalskill update",globalskills);
    }
    else
    {
      console.log("No data found")
    }
  }
}
const inputHandler1 = async (e) => {
  const optionvalue = e.target.value;
  setInputValue(optionvalue);
 // console.log(optionvalue);
  if(globalvalue.includes(optionvalue) || localvalue.includes(optionvalue)  || cognitivevalue.includes(optionvalue) ||decisionautomationsvalue.includes(optionvalue) || genAIvalue.includes(optionvalue))
  {

  }
  else
  {
    let auth = JSON.parse(localStorage.getItem("auth")).data;
    const { data } = await axios({
      url: `${endpoints.baseUrl}/botSearch/globalLocal?botID=${optionvalue}`,
      method: "GET",
      headers: {
        Authorization: `${auth.accessToken}|${auth.email}`,
      },
      data: {
        botID: optionvalue,
      },
    });
    //console.log(data);
    if (data.code === 200) {
      setLocalskills(data.data);
      setCheckedL(true);
     // console.log(data.data);
      //console.log("globalskill update",globalskills);
    }
    else
    {
      console.log("No data found")
    }
  }
}

//for cognitive skill
const inputHandlerc = async (e) => {
  const optionvalue = e.target.value;
  setInputValuec(optionvalue);
 // console.log(optionvalue);
  if(globalvalue.includes(optionvalue) || localvalue.includes(optionvalue) || cognitivevalue.includes(optionvalue) ||decisionautomationsvalue.includes(optionvalue) || genAIvalue.includes(optionvalue))
  {

  }
  else
  {
    let auth = JSON.parse(localStorage.getItem("auth")).data;
    const { data } = await axios({
      url: `${endpoints.baseUrl}/botSearch/globalLocal?botID=${optionvalue}`,
      method: "GET",
      headers: {
        Authorization: `${auth.accessToken}|${auth.email}`,
      },
      data: {
        botID: optionvalue,
      },
    });
    console.log(data);
    if (data.code === 200) {
      setCognitiveskills(data.data);
      
      setCheckedC(true);
     // console.log(data.data);
      //console.log("globalskill update",globalskills);
    }
    else
    {
      console.log("No data found")
    }
  }
}
//for decision automation skill
const inputHandlerd = async (e) => {
  const optionvalue = e.target.value;
  setInputValued(optionvalue);
 // console.log(optionvalue);
  if(globalvalue.includes(optionvalue) || localvalue.includes(optionvalue) || cognitivevalue.includes(optionvalue) ||decisionautomationsvalue.includes(optionvalue) || genAIvalue.includes(optionvalue))
  {

  }
  else
  {
    let auth = JSON.parse(localStorage.getItem("auth")).data;
    const { data } = await axios({
      url: `${endpoints.baseUrl}/botSearch/globalLocal?botID=${optionvalue}`,
      method: "GET",
      headers: {
        Authorization: `${auth.accessToken}|${auth.email}`,
      },
      data: {
        botID: optionvalue,
      },
    });
    console.log(data);
    if (data.code === 200) {
      setDecisionautomationsskills(data.data)
      
      setCheckedD(true);
     // console.log(data.data);
      //console.log("globalskill update",globalskills);
    }
    else
    {
      console.log("No data found")
    }
  }
}

 //for genAI skills
  const inputHandlerg = async (e) => {
    const optionvalue = e.target.value;
    setInputValueg(optionvalue);
    console.log("optionvalue", typeof optionvalue);
    console.log("globalvalue", globalvalue);
    console.log("localvalue", localvalue);
    console.log("optionvalue", optionvalue);
    console.log("softskill", softskills);
    if (
      globalvalue.includes(optionvalue) ||
      localvalue.includes(optionvalue) ||
      cognitivevalue.includes(optionvalue) ||
      decisionautomationsvalue.includes(optionvalue) ||
      genAIvalue.includes(optionvalue)
    ) {
    } else {
      let auth = JSON.parse(localStorage.getItem("auth")).data;
      const { data } = await axios({
        url: `${endpoints.baseUrl}/botSearch/globalLocal?botID=${optionvalue}`,
        method: "GET",
        headers: {
          Authorization: `${auth.accessToken}|${auth.email}`,
        },
        data: {
          botID: optionvalue,
        },
      });
      console.log("setGenAISkills", data.data);
      if (data.code === 200) {
        setGenAISkills(data.data);
        setCheckedG(true);
      } else {
        console.log("No data found");
      }
    }

    if (optionvalue.startsWith("SS") && !items.includes(optionvalue)) {
      if (items.includes(optionvalue) || genAIvalue.includes(optionvalue)) {
      } else {
        try {
          let auth = JSON.parse(localStorage.getItem("auth")).data;
          const { data } = await axios({
            url: `${endpoints.baseUrl}/softSkill/get?softSkillID=${optionvalue}`,
            method: "GET",
            headers: {
              Authorization: `${auth.accessToken}|${auth.email}`,
            },
            data: {
              softSkillID: optionvalue,
            },
          });
          if (data.code === 200) {
            console.log("skilldata", data);
            console.log("softSkillID", data.data[0].softSkillID);
            setGenAISkills(data.data);
            setCheckedG(true);
          }
        } catch (error) {
          console.log("Error", error);
        }
      }
    }
  };


//for global and transaction skill
const checkedGlobal = (e) => {
  setChecked(false);
  setInputValue1('');
  setGlobalvalue(
    [...globalvalue,e.target.value]);
  
};
	const checkedProduct = (e) => {	
  setCheckedP(false);	
  setInputValue1('');	
  setProductvalue(	
    [...productvalue,e.target.value]);	
    submitemptwinFormp(e.target.name)  	
};
const submitemptwinFormp = async (prodid) => {
  console.log(prodid);
  let auth = JSON.parse(localStorage.getItem("auth")).data;
  axios({
    method: "POST",
    url: `${endpoints.baseUrl}/twin/store_product`,
    headers: {
      Authorization: `${auth.accessToken}|${auth.email}`,
    },
    data: {
      product_id: prodid,
    },
  }).then((resp) => {
    if (resp.data.code == 403) {
    } else if (resp.status == 200) {
      console.log("data from api---->", resp);
    } else if (resp.data.code == 400) {
    }
  });
};
//for reporting and local skill
const checkedLocal = (e) => {
  setCheckedL(false);
  
  setLocalvalue(
    [...localvalue,e.target.value]);
  setInputValue('');
  
};
//for cognitive skill
const checkedCognitive = (e) => {
  setCheckedC(false);
  setInputValuec('');
  setCognitivevalue(
    [...cognitivevalue,e.target.value]);
  
};
//for decisionautomation skill
const checkedDecision = (e) => {
  setCheckedD(false);
  setInputValued('');
  setDecisionautomationsvalue(
    [...decisionautomationsvalue,e.target.value]);
 
};

 //for GenAI  skill
  const checkedGenAI = (e) => {
    setCheckedG(false);
    setInputValueg("");
    setGenAIvalue([...genAIvalue, e.target.value]);
  };


const deleteByValue = item => {
  setGlobalvalue(oldValues => {
    return oldValues.filter(globalvalue => globalvalue !== item)
  })
  setLocalvalue(oldValues => {
    return oldValues.filter(localvalue => localvalue !== item)
  })
  setSkillvalue(oldValues => {
    return oldValues.filter(skillvalue => skillvalue !== item)
  })
   setProductvalue(oldValues => {	
    return oldValues.filter(productvalue => productvalue !== item)	
  })
   setCognitivevalue(oldValues => {
    return oldValues.filter(cognitivevalue => cognitivevalue !== item)
  })
  setDecisionautomationsvalue(oldValues => {
    return oldValues.filter(decisionautomationsvalue => decisionautomationsvalue !== item)
  })
  setGenAIvalue((oldValues) => {
      return oldValues.filter((genAIvalue) => genAIvalue !== item);
    });
}
const deleteByValue1 = index => {
  const storedArray = JSON.parse(localStorage.getItem('myData'));
  storedArray.splice(index, 1);
    localStorage.setItem('myData', JSON.stringify(storedArray));
    setSkillvalue(storedArray);
  // if (storedArray) {
  //   setSkillvalue(storedArray);
  // }
  // setSkillvalue(oldValues => {
  //   return oldValues.filter(skillvalue => skillvalue !== item)
  // })
}
//console.log("line number 64",leadState);


  /*end upload file code*/
  function openpopup()
  {
    let modal = !softSkillModal;
    setsoftSkillModal(true);
    if (modal === true) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }
  React.useEffect(() => {
    let emailCheckAr = [];
    let numberCheckAr = [];
    let requiredFields = [];

    setEmailCheck([...emailCheckAr]);
    setNumberCheck([...numberCheckAr]);
    
  }, []);


  function alphanumric(val) {
    const re = /^[a-z][a-zA-Z0-9_]*$/;

    if (re.test(String(val))) {
      return true;
    } else {
      return false;
    }

    // return re.test(String(email).toLowerCase());
  }
  function camelize(str) {
    // return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
    //     return index === 0 ? word.toLowerCase() : word.toUpperCase();
    //   })
    //   .replace(/\s+/g, "");
  }

  {/*React.useEffect(() => {
    emptwinForm.splice(17, 0, countryData);
    emptwinForm.splice(17, 0, mcoData);
    emptwinForm.splice(17, 0, clusterData);

    emptwinForm.splice(17, 0, subAreaData);
    emptwinForm.splice(17, 0, areaData);
    emptwinForm.splice(17, 0, leadPlatformData);

  }, []);*/}

  const [state, setState] = React.useState(initialStates);


React.useEffect(() => {
  
  //console.log("dropdown data at line 395",state);
  const storedArray = JSON.parse(localStorage.getItem('myData'));
  if (storedArray) {
    setSkillvalue(storedArray);
  }
}, []);
let a=[];
let b=[];
let c=[];
const localHandler = async (e) => {
  let auth = JSON.parse(localStorage.getItem("auth")).data;
  const { data } = await axios({
    url: `${endpoints.baseUrl}/twin/search?empTwinId=${empid}`,
    method: "GET",
    headers: {
      Authorization: `${auth.accessToken}|${auth.email}`,
    },

  });
  //console.log(data);
  if (data.code === 200) {
    setEmptwin(data.allSkill[0]);
    a= data.allSkill[0].globalSkill;
     if(a=="")
    {
      setGlobalvalue([]);
    }
    else{
     let globals=a.split(",");
     setGlobalvalue(globals);
    }
    b= data.allSkill[0].localSkill;
    if(b=="")
    {
      setLocalvalue([]);
    }
    else{
      let locals=b.split(",");
      setLocalvalue(locals);
    }
    c= data.allSkill[0].softSkill;
    let softs=c.split(",");
    localStorage.setItem('myData', JSON.stringify(softs));
    const storedArray = JSON.parse(localStorage.getItem('myData'));
    let d=data.allSkill[0].mco;
    let mco=d.split(",")
    setSelectedOptions(mco);
    let e=data.allSkill[0].country;
    let country=e.split(",")
    setSelectedcountryOptions(country);
    let f= data.allSkill[0].product_id;	
    if(f==""){
      setProductvalue([]);
    }
    else{
     let pids=f.split(",");	
     setProductvalue(pids);
    }
    let cognitive= data.allSkill[0].cognitive;
    if(cognitive=="")
    {
      setCognitivevalue([]);
    }
    else
    {
      let cognitivedata=cognitive.split(",");
      setCognitivevalue(cognitivedata);
    }

    let decision= data.allSkill[0].decisionautomations;
    if(decision==""){
      setDecisionautomationsvalue([]);
    }
    else{
      let decisiondata=decision.split(",");
      setDecisionautomationsvalue(decisiondata);
    }
    let genAI = data.allSkill[0].genAi;
      if (genAI == "") {
        setGenAIvalue([]);
      } else {
        let genAIData = genAI.split(",");
        setGenAIvalue(genAIData);
      }
  }
  else
  {
    console.log("No data found")
  }

}


//setGlobalvalue(emptwin.globalSkill);
React.useEffect(() => {
localHandler();
},[])
const [relatedDropdowns, setRelatedDropdowns] = React.useState(null);


let indexForArea,indexForsubarea,indexForMCO,indexforcountry;

const [softskills,setSoftskills]=useState([]);


const inputHandlers = async (e) => {
  const optionvalue = e.target.value;
 if(items.includes(optionvalue))
  {
      
  }
  else
  {
      
   let auth = JSON.parse(localStorage.getItem("auth")).data;
   const { data } = await axios({
      url: `${endpoints.baseUrl}/softSkill/get?softSkillID=${optionvalue}`,
      method: "GET",
      headers: {
        Authorization: `${auth.accessToken}|${auth.email}`,
      },
      data: {
        softSkillID: optionvalue,
      },
    });
    //console.log(data);
    if (data.code === 200) {
      setSoftskills(data.data);
    }
    else
    {
      console.log("No data found")
    }
  }
  setCheckedS(true);

}


let ssid;
const softidfrommodal = (skillid) => {
  ssid = skillid;
  console.log(ssid);
};

  return (
   
    <div className={styles.mainContain}>
     {loader ? <Loader /> : null}
      <div className={`${styles.formContainer}`}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2 className={styles.head}>Edit Employee Twin</h2>
            </div>
            <div className="col-md-12">
              <p className={styles.text}>
                Change details in the form below to edit a Employee Twin.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className={`${styles.inputGroupWrapper}`}>
        <div className={`${styles.Group} container`}>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-12">
              <div className={styles.formGroup}>
                <div className={styles.combine}>
                  <label className={styles.mainLabel}>
                    {_get(emptwinForm[0].component.content, "field_label", "")}
                    <sup className={styles.mandatoryField}>*</sup>
                  </label>
                </div>
                <div className={styles}>
                  {_get(
                    emptwinForm[0].component.content,
                    "field_options",
                    []
                  ).map((item, index) => {
                    return (
                      <label className={styles.radioWrapper} key={index}>
                        <span className={styles.subLabel}>{item}</span>
                        <input
                          type="radio"
                          className={styles.radioBox}
                          name="requestType"
                          value={item}
                          checked
                        />
                        <span className={styles.radioCheckmark}></span>
                      </label>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <div className={styles.formGroup}>
                <div className={styles.combine}>
                  <label className={styles.mainLabel}>
                    {_get(
                      emptwinForm[1].component.content,
                      "field_form_field_title",
                      ""
                    )}
                    <sup className={styles.mandatoryField}>*</sup>
                  </label>
                  {invalidFlag ? (
                    <span className={styles.errorMessage}>
                      {_get(
                        emptwinForm[1].component.content,
                        "field_message_ip_error_message",
                        ""
                      )}
                    </span>
                  ) : null}
                </div>

                {/*                
                  <select className={styles.select}>
                  <option defaultValue> {_get(
                      emptwinForm[1].component.content,
                      "field_form_field_title",
                      ""
                    )}</option>
                  {_get(
                    emptwinForm[1].component.content,
                    "field_options",
                    []
                  ).map((item, index) => {
                    return (
                      <option value={item} key={index}>{item}</option>
                    )
                  })
                  }
                </select> */}
                <input
                  type="text"
                  className={styles.inputtext}
                  name="employeeTwinID"
                  id="employeeTwinID"
                  readOnly
                  value={empid}
                />
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <div className={styles.formGroup}>
                <div className={styles.combine}>
                  <label className={styles.mainLabel}>
                    {_get(
                      emptwinForm[2].component.content,
                      "field_form_field_title",
                      ""
                    )}
                    <sup className={styles.mandatoryField}>*</sup>

                    {/* {submitForm?
                    (emptwin1.employeeTwinName == "" && emptwin1.employeeTwinName.length == 0)?(
                    <span className={styles.errorMessage}>
                      {_get(
                        emptwinForm[2].component.content,
                        "field_message_ip_error_message",
                        ""
                      )}
                    </span>
                  ) : null:null
                  } */}
                  </label>
                </div>

                <input
                  type="text"
                  className={styles.inputtext}
                  name="employeeTwinName"
                  id="employeeTwinName"
                  onChange={onValueChange}
                  value={emptwin.employeeTwinName}
                />
              </div>
            </div>
            <div className="col-lg-12 col-md-12 col-12">
              <div className={styles.formGroup}>
                <div className={styles.combine}>
                  <label className={styles.mainLabel}>
                    {_get(
                      emptwinForm[3].component.content,
                      "field_form_field_title",
                      ""
                    )}
                    <sup className={styles.mandatoryField}>*</sup>
                    {/* {submitForm?
                    (emptwin1.employeeTwinDescription == "" && emptwin1.employeeTwinDescription.length == 0)?(
                    <span className={styles.errorMessage}>
                      {_get(
                        emptwinForm[3].component.content,
                        "field_message_ip_error_message",
                        ""
                      )}
                    </span>
                  ) : null:null
                  } */}
                  </label>
                </div>

                <textarea
                  className={`${invalidFlag ? styles.errorBorder : null}`}
                  name="employeeTwinDescription"
                  id="employeeTwinDescription"
                  onChange={onValueChange}
                  value={emptwin.employeeTwinDescription}
                ></textarea>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <div className={styles.formGroup}>
                <div className={`${styles.uploadBtnWrapper}`}>
                  <div className={styles.uploadFileContainer}>
                    <label className={styles.mainLabel}>
                      Upload Logo
                      <sup className={styles.mandatoryField}>*</sup>
                    </label>
                  </div>
                  <div className="flex justify-between items-center">
                    <div className="flex">
                      <input
                        type="file"
                        className={styles.aa}
                        name="logoFile"
                        id="employeeTwinName"
                        onChange={handleFileChange}
                        // value={logoFile}
                      />
                      <p className="text-red-400">Selected....!!!</p>
                    </div>
                    <img
                      src="./assets/img/Rectangle-347.png"
                      alt=""
                      className="w-10"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <div className={styles.formGroup}>
                <div className={styles.combine}>
                  <label className={styles.mainLabel}>
                    {_get(
                      emptwinForm[5].component.content,
                      "field_form_field_title",
                      ""
                    )}
                    <sup className={styles.mandatoryField}>*</sup>
                    {/* {submitForm?
                    (emptwin1.status == "" && emptwin1.status.length == 0)?(
                    <span className={styles.errorMessage}>
                      {_get(
                        emptwinForm[5].component.content,
                        "field_message_ip_error_message",
                        ""
                      )}
                    </span>
                  ) : null:null
                  } */}
                  </label>
                </div>

                <select
                  className={styles.select}
                  onChange={onValueChange}
                  name="status"
                  id="status"
                  value={emptwin.status}
                >
                  <option defaultValue>
                    {" "}
                    {_get(
                      emptwinForm[5].component.content,
                      "field_form_field_title",
                      ""
                    )}
                  </option>
                  {_get(
                    emptwinForm[5].component.content,
                    "field_options",
                    []
                  ).map((item, index) => {
                    return (
                      <option value={item} key={index}>
                        {item}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>

            {/* Code Start For Dropdowns  */}
            <div className="col-lg-6 col-md-6 col-12">
              <div className={styles.formGroup}>
                <div className={styles.combine}>
                  <label className={styles.mainLabel}>
                    Lead Platform
                    <sup className={styles.mandatoryField}>*</sup>
                  </label>
                </div>

                <select
                  value={emptwin.leadPlatform}
                  className={styles.select}
                  onChange={onValueChange}
                  name="leadPlatform"
                  id="leadPlatform"
                >
                  {_get(leadPlatformData, "field_options", []).map(
                    (item, index) => {
                      emptwin.leadPlatform == item
                        ? (indexForArea = index)
                        : null;
                      return (
                        <option value={item} key={index}>
                          {item}
                        </option>
                      );
                    }
                  )}
                </select>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-12">
              <div className={styles.formGroup}>
                <div className={styles.combine}>
                  <label className={styles.mainLabel}>
                    Area
                    <sup className={styles.mandatoryField}>*</sup>
                  </label>
                </div>

                <select
                  value={emptwin.area}
                  className={styles.select}
                  onChange={onValueChange}
                  name="area"
                  id="area"
                >
                  {_get(
                    areaData.field_dropdown_option_component[indexForArea],
                    "field_options",
                    []
                  ).map((item, index) => {
                    return (
                      <option value={item} key={index}>
                        {item}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <div className={styles.formGroup}>
                <div className={styles.combine}>
                  <label className={styles.mainLabel}>
                    Sub Area
                    <sup className={styles.mandatoryField}>*</sup>
                  </label>
                </div>

                <select
                  value={emptwin.subArea}
                  className={styles.select}
                  onChange={onValueChange}
                  name="subArea"
                  id="subArea"
                >
                  {_get(subAreaData, "field_dropdown_option_component", []).map(
                    (item, index) => {
                      emptwin.area == item.field_title
                        ? (indexForsubarea = index)
                        : null;
                      {
                        /* console.log('emptwinForm[17]',indexForsubarea) */
                      }
                    }
                  )}
                  <option >Choose Subarea</option>
                  {_get(
                    subAreaData.field_dropdown_option_component[
                      indexForsubarea
                    ],
                    "field_options",
                    []
                  ).map((item, index) => {
                    {
                      /* console.log('field_options',item); */
                    }
                    return (
                      <option value={item} key={index}>
                        {item}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <div className={styles.formGroup}>
                <div className={styles.combine}>
                  <label className={styles.mainLabel}>
                    Cluster
                    <sup className={styles.mandatoryField}>*</sup>
                  </label>
                </div>

                <select
                  value={emptwin.cluster}
                  className={styles.select}
                  onChange={onValueChange}
                  name="cluster"
                  id="cluster"
                >
                  {_get(clusterData, "field_options", []).map((item, index) => {
                    emptwin.cluster == item ? (indexForMCO = index) : null;
                    return (
                      <option value={item} key={index}>
                        {item}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <div className={styles.formGroup}>
                <div className={styles.combine}>
                  <label className={styles.mainLabel}>
                    MCO
                    <sup className={styles.mandatoryField}>*</sup>
                  </label>
                </div>
                <div
                  value={emptwin.mco}
                  className={styles.selectdropdown}
                  onClick={onToggle}

                >
                  <option>{selectedOptions.length} Value Selected</option>
                  {_get(
                    mcoData.field_dropdown_option_component[indexForMCO],
                    "field_options",
                    []
                  ).map((item, index) => {})}
                </div>
                {toggle?
                <ul className={styles.checkboxdropdown}>
                  {_get(
                    mcoData.field_dropdown_option_component[indexForMCO],
                    "field_options",
                    []
                  ).map((item, index) => (
                    <li key={index}>
                      <label>
                        <input
                          type="checkbox"
                          value={item}
                          checked={selectedOptions.includes(item)}
                          onChange={handleSelect}
                          name="mco"
                          id="mco"
                        />
                        {item}
                      </label>
                    </li>
                  ))}
                </ul>:null
                }
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <div className={styles.formGroup}>
                <div className={styles.combine}>
                  <label className={styles.mainLabel}>
                    Country
                    <sup className={styles.mandatoryField}>*</sup>
                  </label>
                </div>
                <div
                  value={emptwin.country}
                  className={styles.selectdropdown}
                  onClick={onTogglen}
                >
                  <option>{selectedcountryOptions.length} Value Selected</option>
                </div>
                {togglen?
                <ul className={styles.checkboxdropdown}>
                  {_get(
                    countryData,
                    "field_dropdown_option_component",
                    []
                  ).map((item, index) => (
                    <>
                    {selectedOptions.includes(item.field_title)?
                    _get(
                    countryData.field_dropdown_option_component[index],
                    "field_options",
                    []
                  ).map((item, index) => (
                    <li>
                      <label>
                        <input
                          type="checkbox"
                          value={item}
                          checked={selectedcountryOptions.includes(item)}
                          onChange={handleSelectcountry}
                          name="country"
                          id="country"
                        />
                        {item}
                      </label>
                    </li>)):null}
                    </>
                  ))}
                </ul>:null
                }
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <div className={styles.formGroup}>
                <div className={styles.combine}>
                  <label className={styles.mainLabel}>
                    {_get(
                      emptwinForm[6].component.content,
                      "field_form_field_title",
                      ""
                    )}
                    <sup className={styles.mandatoryField}>*</sup>
                    {/* {submitForm?
                    (emptwin1.geoItPartner == "" && emptwin1.geoItPartner.length == 0)?(
                    <span className={styles.errorMessage}>
                      {_get(
                        emptwinForm[6].component.content,
                        "field_message_ip_error_message",
                        ""
                      )}
                    </span>
                  ) : null:null
                  } */}
                  </label>
                </div>

                <input
                  type="text"
                  className={styles.inputtext}
                  name="geoItPartner"
                  id="geoItPartner"
                  onChange={onValueChange}
                  value={emptwin.geoItPartner}
                />
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-12">
              <div className={styles.formGroup}>
                <div className={styles.combine}>
                  <label className={styles.mainLabel}>
                    {_get(
                      emptwinForm[7].component.content,
                      "field_form_field_title",
                      ""
                    )}
                    <sup className={styles.mandatoryField}>*</sup>
                    {/* {submitForm?
                    (emptwin1.businessOwner == "" && emptwin1.businessOwner.length == 0)?(
                    <span className={styles.errorMessage}>
                      {_get(
                        emptwinForm[7].component.content,
                        "field_message_ip_error_message",
                        ""
                      )}
                    </span>
                  ) : null:null
                  } */}
                  </label>
                </div>

                <input
                  type="text"
                  className={styles.inputtext}
                  name="businessOwner"
                  id="businessOwner"
                  onChange={onValueChange}
                  value={emptwin.businessOwner}
                />
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-12">
              <div className={styles.formGroup}>
                <div className={styles.combine}>
                  <label className={styles.mainLabel}>
                    {_get(
                      emptwinForm[8].component.content,
                      "field_form_field_title",
                      ""
                    )}
                    <sup className={styles.mandatoryField}>*</sup>
                    {/* {submitForm?
                    (emptwin1.engagementLead == "" && emptwin1.engagementLead.length == 0)?(
                    <span className={styles.errorMessage}>
                      {_get(
                        emptwinForm[8].component.content,
                        "field_message_ip_error_message",
                        ""
                      )}
                    </span>
                  ) : null:null
                  } */}
                  </label>
                </div>

                <select
                  className={styles.select}
                  id="engagementLead"
                  name="engagementLead"
                  onChange={onValueChange}
                  value={emptwin.engagementLead}
                >
                  <option defaultValue>
                    {" "}
                    {_get(
                      emptwinForm[8].component.content,
                      "field_form_field_title",
                      ""
                    )}
                  </option>
                  {_get(
                    emptwinForm[8].component.content,
                    "field_options",
                    []
                  ).map((item, index) => {
                    return (
                      <option value={item} key={index}>
                        {item}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
           {/* <div className="col-lg-6 col-md-6 col-12">
              <div className={styles.formGroup}>
                <div className={styles.combine}>
                  <label className={styles.mainLabel}>
                    {_get(
                      emptwinForm[9].component.content,
                      "field_form_field_title",
                      ""
                    )}
                    <sup className={styles.mandatoryField}>*</sup>
                     {submitForm?
                    (!globalvalue == "" && globalvalue.length == 0)?(
                    <span className={styles.errorMessage}>
                      {_get(
                        emptwinForm[9].component.content,
                        "field_message_ip_error_message",
                        ""
                      )}
                    </span>
                  ) : null:null
                  } 
                  </label>
                </div>

                <input
                  type="text"
                  className={styles.inputtext}
                  onChange={(e) => {
                    inputHandler(e);
                  }}
                  placeholder="Search Global skill"
                  value={inputValue1}
                />
                <input
                  type="hidden"
                  id="globalskill"
                  name="globalskill"
                  value={globalvalue}
                />
                {checked
                  ? globalskills.map((item, index) => (
                      <label className={styles}>
                        <input
                          type="checkbox"
                          value={item.botExternalId}
                          onChange={(e) => {
                            checkedGlobal(e);
                          }}
                        />
                        <span className={styles.lableHead}>
                          {item.processName}
                        </span>
                      </label>
                    ))
                  : null}
               {checkedP?	
                productids.map((item, index) => (	
                  <label className={styles}>	
                    	
                      <input type="checkbox" value={item.pid} name={item.product_id}  onChange={(e) => {checkedProduct(e)}} />	
                      <span className={styles.lableHead}>{item.product_title}</span>	
                  </label>	
                )):null}
                <ul>
                  {globalvalue.map((item, index) => (
                    <li className={styles.checkedvalue} id={index}>
                      {item}{" "}
                      <span
                        onClick={() => {
                          deleteByValue(item);
                        }}
                        className={styles.globallist}
                      >
                        X
                      </span>
                    </li>
                  ))}
                {productvalue.map((item, index)=>(	
                <li className={styles.checkedvalue} id={index}>	
                {item} <span onClick={()=>{deleteByValue(item)}} className={styles.globallist}>X</span>	
               </li>	
                 ) )}
                </ul>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <div className={styles.formGroup}>
                <div className={styles.combine}>
                  <label className={styles.mainLabel}>
                    {_get(
                      emptwinForm[10].component.content,
                      "field_form_field_title",
                      ""
                    )}
                    <sup className={styles.mandatoryField}>*</sup>
                    {submitForm?
                    (!localvalue == "" && localvalue.length == 0)?(
                    <span className={styles.errorMessage}>
                      {_get(
                        emptwinForm[10].component.content,
                        "field_message_ip_error_message",
                        ""
                      )}
                    </span>
                  ) : null:null
                  } 
                  </label>
                </div>

                <input
                  type="text"
                  className={styles.inputtext}
                  onChange={(e) => {
                    inputHandler1(e);
                  }}
                  placeholder="Search Local skill"
                  value={inputValue}
                />
                <input
                  type="hidden"
                  name="localskill"
                  id="localskill"
                  value={localvalue}
                />
                {checkedL
                  ? localskills.map((item, index) => (
                      <label className={styles}>
                        <input
                          type="checkbox"
                          value={item.botExternalId}
                          onChange={(e) => {
                            checkedLocal(e);
                          }}
                        />
                        <span className={styles.lableHead}>
                          {item.processName}
                        </span>
                      </label>
                    ))
                  : null}
                <ul>
                  {localvalue.map((item, index) => (
                    <li className={styles.checkedvalue} id={index}>
                      {item}{" "}
                      <span
                        onClick={() => {
                          deleteByValue(item);
                        }}
                        className={styles.globallist}
                      >
                        X
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>*/}

       
            <div className="col-lg-6 col-md-6 col-12">
              <div className={styles.formGroup}>
                <div className={styles.combine}>
                  <label className={styles.mainLabel}>
                    {_get(
                      emptwinForm[11].component.content,
                      "field_form_field_title",
                      ""
                    )}
                   {/* <sup className={styles.mandatoryField}>*</sup> */}
                    {/* {submitForm?
                    (!items == "" && items.length == 0)?(
                    <span className={styles.errorMessage}>
                      {_get(
                        emptwinForm[11].component.content,
                        "field_message_ip_error_message",
                        ""
                      )}
                    </span>
                  ) : null:null
                  } */}
                  </label>
                </div>

 {/*               <input
                  type="text"
                  className={styles.inputtext}
                  onClick={() => {
                    openpopup();
                  }}
                  placeholder="Search Soft skill"
                />*/}
              <div>
                <input
                  type="text"
                  className={styles.inputtext}
                  onChange={(e)=>{inputHandlers(e)}}
                  placeholder="Search Soft skill"
                />
                {checkedS?
                
                softskills.map((item, index) => (
                                     <label className={styles}>
                                       <input type="checkbox" value={item.softSkillID} onChange={(e) => {checkedSoft(e)}}/>
                                       <span className={styles.lableHead}>{item.skillName}</span>
                                 </label>))
               :null}
               </div>
               <button className={`${styles.button} ${styles.softskillAdd}`}
                  onClick={() => {openpopup()}} >Add</button>
                <input
                  type="hidden"
                  name="softskill"
                  id="softskill"
                  value={items}
                />
                <ul>
                  {items.map((item, index) => (
                    <li className={styles.checkedvalue} id={index}>
                      {item}{" "}
                      <span
                        onClick={() => {
                          deleteByValue1(index);
                        }}
                        className={styles.globallist}
                      >
                        X
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            {/*<div className="col-lg-6 col-md-6 col-12">
              <div className={styles.formGroup}>
                <div className={`${styles.uploadBtnWrapper}`}>
                  <div className={styles.uploadFileContainer}>
                    <label className={styles.mainLabel}>
                      {_get(
                        emptwinForm[12].component.content,
                        "field_title",
                        ""
                      )}
                      <sup className={styles.mandatoryField}>*</sup>
                    </label>
                    <div className={`${styles.uploadBtnWrapper}`}>
                      <div className={styles.uploadFileContainer}>
                        
                        <div className={styles.uploadControl}>
                          <div className={styles.uploadFileContainer}>
                            <UploadFileComponent
                              type="document"
                              fileType={fileTypes}
                              uploadFile={uploadFile1}
                              uploaded={showFileName1}
                              value="document"
                              name="editemployeetwin"
                            />
                          </div>

                          <div
                            className={styles.actionBtn}
                            onClick={uploadButtonClick1}
                          >
                            <span>
                              <Icons
                                name="uploadicon"
                                className={styles.uploadIcon}
                              ></Icons>
                              Upload File
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
*/}
<div className="col-lg-6 col-md-6 col-12">		
              <div className={styles.formGroup}>		
              		
                <div className={`${styles.uploadBtnWrapper}`}>		
                  <div className={styles.uploadFileContainer}>		
                  <label className={styles.mainLabel}>		
                  {_get(		
                      emptwinForm[12].component.content,		
                      "field_title",		
                      ""		
                    )}		
                  		
                    		
                  {/*{submitForm?		
                    (softdocument?(		
                    <span className={styles.errorMessage}>		
                    Please upload SOP Document		
                    </span>		
                  ):null):null		
                  		
                             }*/}                  		
</label>		
                  <div className={styles.uploadControl}>		
               		
		<div className={styles.multiDocsWrapper}>		
            <span className={styles.skillMultiDocs} 		
            onClick={openDocumentModal}		
            >		
              Open Document Uploader		
            </span>		
          </div>		
      </div>		
                    		
                  </div>		
                </div>		
              </div>		
            </div>	

            <div className="col-lg-6 col-md-6 col-12">
              <div className={styles.formGroup}>
                <div className={styles.combine}>
                  <label className={styles.mainLabel}>
                    {_get(
                      emptwinForm[13].component.content,
                      "field_form_field_title",
                      ""
                    )}
                    <sup className={styles.mandatoryField}>*</sup>
                    {/* {submitForm?
                    (emptwin1.manualhour == "" && emptwin1.manualhour.length == 0)?(
                    <span className={styles.errorMessage}>
                      {_get(
                        emptwinForm[13].component.content,
                        "field_message_ip_error_message",
                        ""
                      )}
                    </span>
                  ) : null:null
                  } */}
                  </label>
                </div>

                <input
                  type="number"
                  className={styles.inputtext}
                  name="manualhour"
                  id="manualhour"
                  onChange={onValueChange}
                  value={emptwin.manualhour}
                />
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <div className={styles.formGroup}>
                <div className={styles.combine}>
                  <label className={styles.mainLabel}>
                    {_get(
                      emptwinForm[14].component.content,
                      "field_form_field_title",
                      ""
                    )}
                    <sup className={styles.mandatoryField}>*</sup>
                    {/* {submitForm?
                    (emptwin1.fte == "" && emptwin1.fte.length == 0)?(
                    <span className={styles.errorMessage}>
                      {_get(
                        emptwinForm[14].component.content,
                        "field_message_ip_error_message",
                        ""
                      )}
                    </span>
                  ) : null:null
                  } */}
                  </label>
                </div>

                <input
                  type="number"
                  className={styles.inputtext}
                  name="fte"
                  id="fte"
                  onChange={onValueChange}
                  value={emptwin.fte}
                />
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-12">
              <div className={styles.formGroup}>
                <div className={styles.combine}>
                  <label className={styles.mainLabel}>
                    {_get(
                      emptwinForm[15].component.content,
                      "field_form_field_title",
                      ""
                    )}
                    <sup className={styles.mandatoryField}>*</sup>
                    
                  </label>
                </div>

                <select
                  className={styles.select}
                  id="businessgroup"
                  name="businessgroup"
                  onChange={onValueChange}
                  value={emptwin.businessgroup}
                >
                  <option defaultValue>
                    {" "}
                    {_get(
                      emptwinForm[15].component.content,
                      "field_form_field_title",
                      ""
                    )}
                  </option>
                  {_get(
                    emptwinForm[15].component.content,
                    "field_options",
                    []
                  ).map((item, index) => {
                    return (
                      <option value={item} key={index}>
                        {item}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <div className={styles.formGroup}>
                <div className={styles.combine}>
                  <label className={styles.mainLabel}>
                    {_get(
                      emptwinForm[16].component.content,
                      "field_form_field_title",
                      ""
                    )}
                    <sup className={styles.mandatoryField}>*</sup>
                    
                  </label>
                </div>

                <select
                  className={styles.select}
                  id="businessunit"
                  name="businessunit"
                  onChange={onValueChange}
                  value={emptwin.businessunit}
                >
                  <option defaultValue>
                    {" "}
                    {_get(
                      emptwinForm[16].component.content,
                      "field_form_field_title",
                      ""
                    )}
                  </option>
                  {_get(
                    emptwinForm[16].component.content,
                    "field_options",
                    []
                  ).map((item, index) => {
                    return (
                      <option value={item} key={index}>
                        {item}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
                {(emptwin.businessunit != 'Global') ? (<div className="col-lg-6 col-md-6 col-12">
              <div className={styles.formGroup}>
                <div className={styles.combine}>
                  <label className={styles.mainLabel}>
                    Business Group Unit
                    {/*<sup className={styles.mandatoryField}>*</sup>*/}
                    
                  </label>
                </div>

                <select
                  className={styles.select}
                  id="businessoption"
                  name="businessoption"
                  onChange={onValueChange}
                  value={emptwin.businessoption}
                >
                 

                  {emptwin.businessgroup == "Beauty & Wellbeing" ||
                  emptwin.businessgroup == "All" ? (
                    <option value="Health & Wellness">
                      Health & Wellness{" "}
                    </option>
                  ) : null}
                  {emptwin.businessgroup == "Beauty & Wellbeing" ||
                  emptwin.businessgroup == "All" ? (
                    <option value="Prestige">Prestige </option>
                  ) : null}
                  {emptwin.businessgroup == "Personal Care" ||
                  emptwin.businessgroup == "All" ? (
                    <option value="Dollar Shave Club">Dollar Shave Club</option>
                  ) : null}
                  {emptwin.businessgroup == "Personal Care" ||
                  emptwin.businessgroup == "All" ? (
                    <option value="Elida Beauty">Elida Beauty</option>
                  ) : null}
                  {emptwin.businessgroup == "Home Care" ||
                  emptwin.businessgroup == "All" ? (
                    <option value="Water and Air Wellness">
                      Water and Air Wellness
                    </option>
                  ) : null}
                  {emptwin.businessgroup == "Nutrition" ||
                  emptwin.businessgroup == "All" ? (
                    <option value="Unilever Food Solutions">
                      Unilever Food Solutions
                    </option>
                  ) : null}
                  {emptwin.businessgroup == "Ice Cream" ||
                  emptwin.businessgroup == "All" ? (
                    <option value="Ice Cream">Ice Cream</option>
                  ) : null}
                </select>
              </div>
            </div>
            ): null}
            <div className="col-lg-6 col-md-6 col-12">
              <div className={styles.formGroup}>
                <div className={styles.combine}>
                  <label className={styles.mainLabel}>
                    Go Live date
                    <sup className={styles.mandatoryField}>*</sup>
                    
                  </label>
                 
                </div>

              <Datetime
              timeFormat={false}
              className={`${styles.calender}  ${styles.errorBorder}`}
              inputProps={inputprops}
              onChange={(date) => handleDate(date, "goLiveDate")}
            />
              </div>
            </div>
             <div className="col-lg-6 col-md-6 col-12">
              <div className={styles.formGroup}>
                <div className={styles.combine}>
                  <label className={styles.mainLabel}>
                    {_get(
                      emptwinForm[18].component.content,
                      "field_form_field_title",
                      ""
                    )}
                    {/* <sup className={styles.mandatoryField}>*</sup>*/}
                   
                  </label>
                </div>

                <input
                  type="text"
                  className={styles.inputtext}
                  onChange={(e) => {
                    inputHandler(e);
                  }}
                  placeholder="Search Transactions skill"
                  value={inputValue1}
                />
                <input
                  type="hidden"
                  id="transactionsskill"
                  name="transactionsskill"
                  value={globalvalue}
                />
                {checked
                  ? globalskills.map((item, index) => (
                      <label className={styles}>
                        <input
                          type="checkbox"
                          value={item.botExternalId}
                          onChange={(e) => {
                            checkedGlobal(e);
                          }}
                        />
                        <span className={styles.lableHead}>
                          {item.processName}
                        </span>
                      </label>
                    ))
                  : null}

                <ul>
                  {globalvalue.map((item, index) => (
                    <li className={styles.checkedvalue} id={index}>
                      {item}{" "}
                      <span
                        onClick={() => {
                          deleteByValue(item);
                        }}
                        className={styles.globallist}
                      >
                        X
                      </span>
                    </li>
                  ))}
             
                </ul>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <div className={styles.formGroup}>
                <div className={styles.combine}>
                  <label className={styles.mainLabel}>
                    {_get(
                      emptwinForm[19].component.content,
                      "field_form_field_title",
                      ""
                    )}
                   {/*  <sup className={styles.mandatoryField}>*</sup> */}
                    
                  </label>
                </div>

                <input
                  type="text"
                  className={styles.inputtext}
                  onChange={(e) => {
                    inputHandler1(e);
                  }}
                  placeholder="Search Reporting skill"
                  value={inputValue}
                />
                <input
                  type="hidden"
                  name="reportingskill"
                  id="reportingskill"
                  value={localvalue}
                />
                {checkedL
                  ? localskills.map((item, index) => (
                      <label className={styles}>
                        <input
                          type="checkbox"
                          value={item.botExternalId}
                          onChange={(e) => {
                            checkedLocal(e);
                          }}
                        />
                        <span className={styles.lableHead}>
                          {item.processName}
                        </span>
                      </label>
                    ))
                  : null}
                <ul>
                  {localvalue.map((item, index) => (
                    <li className={styles.checkedvalue} id={index}>
                      {item}{" "}
                      <span
                        onClick={() => {
                          deleteByValue(item);
                        }}
                        className={styles.globallist}
                      >
                        X
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <div className={styles.formGroup}>
                <div className={styles.combine}>
                  <label className={styles.mainLabel}>
                    {_get(
                      emptwinForm[20].component.content,
                      "field_form_field_title",
                      ""
                    )}
                    {/* <sup className={styles.mandatoryField}>*</sup>*/}
                    
                  </label>
                </div>

                <input
                  type="text"
                  className={styles.inputtext}
                  onChange={(e) => {
                    inputHandlerc(e);
                  }}
                  placeholder="Search Cognitive skill"
                  value={inputValuec}
                />
                <input
                  type="hidden"
                  id="cognitiveskill"
                  name="cognitiveskill"
                  value={cognitivevalue}
                />
                {checkedC
                  ? cognitiveskills.map((item, index) => (
                      <label className={styles}>
                        <input
                          type="checkbox"
                          value={item.botExternalId}
                          onChange={(e) => {
                            checkedCognitive(e);
                          }}
                        />
                        <span className={styles.lableHead}>
                          {item.processName}
                        </span>
                      </label>
                    ))
                  : null}
           
                <ul>
                  {cognitivevalue.map((item, index) => (
                    <li className={styles.checkedvalue} id={index}>
                      {item}{" "}
                      <span
                        onClick={() => {
                          deleteByValue(item);
                        }}
                        className={styles.globallist}
                      >
                        X
                      </span>
                    </li>
                  ))}

                </ul>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <div className={styles.formGroup}>
                <div className={styles.combine}>
                  <label className={styles.mainLabel}>
                    {_get(
                      emptwinForm[21].component.content,
                      "field_form_field_title",
                      ""
                    )}
                    {/* <sup className={styles.mandatoryField}>*</sup>*/}
                   
                  </label>
                </div>

                <input
                  type="text"
                  className={styles.inputtext}
                  onChange={(e) => {
                    inputHandlerd(e);
                  }}
                  placeholder="Search Decision Automations skill"
                  value={inputValued}
                />
                <input
                  type="hidden"
                  name="decisionAutomationsskill"
                  id="decisionAutomationsskill"
                  value={decisionautomationsvalue}
                />
                {checkedD
                  ? decisionautomationsskills.map((item, index) => (
                      <label className={styles}>
                        <input
                          type="checkbox"
                          value={item.botExternalId}
                          onChange={(e) => {
                            checkedDecision(e);
                          }}
                        />
                        <span className={styles.lableHead}>
                          {item.processName}
                        </span>
                      </label>
                    ))
                  : null}
                <ul>
                  {decisionautomationsvalue.map((item, index) => (
                    <li className={styles.checkedvalue} id={index}>
                      {item}{" "}
                      <span
                        onClick={() => {
                          deleteByValue(item);
                        }}
                        className={styles.globallist}
                      >
                        X
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
             
            <div className="col-lg-6 col-md-6 col-12">
              <div className={styles.formGroup}>
                <div className={styles.combine}>
                  <label className={styles.mainLabel}>
                    {_get(
                      emptwinForm[22].component.content,
                      "field_form_field_title",
                      ""
                    )}
                    {/* <sup className={styles.mandatoryField}>*</sup>*/}
                  </label>
                </div>

                <input
                  type="text"
                  className={styles.inputtext}
                  onChange={(e) => {
                    inputHandlerg(e);
                  }}
                  placeholder="Search Gen AI..."
                  value={inputValueg}
                />
                <input
                  type="hidden"
                  name="genAI"
                  id="genAI"
                  value={genAIvalue}
                />
                {checkedG
                  ? genAISkills.map((item, index) => (
                      <label className={styles}>
                        {console.log("selected item", item.botExternalId)}
                        {console.log("selected item", item.softSkillID)}
                        {console.log("selectedItem", item.processName)}
                        {console.log("selectedItem", item.skillName)}
                        {item.botExternalId && (
                          <>
                            <input
                              type="checkbox"
                              value={item.botExternalId}
                              onChange={(e) => {
                                checkedGenAI(e);
                              }}
                            />
                            <span className={styles.lableHead}>
                              {item.processName}
                            </span>
                          </>
                        )}
                        {item.softSkillID && (
                          <>
                            <input
                              type="checkbox"
                              value={item.softSkillID}
                              onChange={(e) => {
                                checkedGenAI(e);
                              }}
                            />
                            <span className={styles.lableHead}>
                              {item.skillName}
                            </span>
                          </>
                        )}
                      </label>
                    ))
                  : null}
                <ul>
                  {genAIvalue.map((item, index) => (
                    <li className={styles.checkedvalue} id={index}>
                      {item}{" "}
                      <span
                        onClick={() => {
                          deleteByValue(item);
                        }}
                        className={styles.globallist}
                      >
                        X
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
              
              <div className="col-lg-6 col-md-6 col-12">
              <div className={styles.formGroup}>
                <div className={styles.combine}>
                  <label className={styles.mainLabel}>
                    {_get(
                      emptwinForm[23].component.content,
                      "field_form_field_title",
                      ""
                    )}
                    {/*  <sup className={styles.mandatoryField}>*</sup>*/}

                    {/* {submitForm?
                    (emptwin1.securityGroupId == "" && emptwin1.securityGroupId.length == 0)?(
                    <span className={styles.errorMessage}>
                      {_get(
                        emptwinForm[2].component.content,
                        "field_message_ip_error_message",
                        ""
                      )}
                    </span>
                  ) : null:null
                  } */}
                  </label>
                </div>

                <input
                  type="text"
                  className={styles.inputtext}
                  name="securityGroupId"
                  id="securityGroupId"
                  onChange={onValueChange}
                  value={emptwin.securityGroupId}
                />
              </div>
            </div>

             <div className={`col-lg-6 col-md-6 ${(emptwin.businessunit != 'Global') ? 'col-12' : `col-lg-12 ${styles.businessGroupUnit}`}`}>
               <div className={styles.formGroup}>
                <button
                  className={styles.submitbtn}
                  onClick={submitemptwinForm}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {softSkillModal ? (
        <SoftSkillModal
          data={props.softskill.data.field_component}
          closeModal={() => {
            setsoftSkillModal(false);
          }}
          setSuccessModal={setSuccessModal}
          setMessage={setMessage}
          setsucessOrFailure={setsucessOrFailure}
          empid={empid}
          name="empskillpage"
          softidfrommodal={softidfrommodal}
        />
      ) : null}
      {successModal ? (
        <SuccessModal
          setSuccessModal={setSuccessModal}
          title={"Soft Skill"}
          message={message}
          fail={sucessOrFailure}
        />
      ) : null}
      {successModal1 ? (
        <SuccessModal
          setSuccessModal={setSuccessModal}
          title={"Employee Twin"}
          message="Employee Twin updated successfully"
          fail={sucessOrFailure}
        />
      ) : null}
      {successModal2 ? (
        <SuccessModal
      setSuccessModal={() => {
              setSuccessModal(false);
              setFileNameError(false);
            }}
            title={"Framework"}
            message={
              filenameError
                ? "Document with this name already exists."
                : "uploaded"
            }
            fail={filenameError ? true : false}
            />
      ) : null}
     <div className={styles.uploadContainer}>			
          {modalShow == true ? (			
            <UploadDoc			
              closeModal={closeDocumentModal}			
              sendDocInfo={gotDocInfo}			
              sendAllInfoAboutUploadModal={sendAllInfoAboutUploadModal}			
              uploadedDocumentsState={uploadedDocumentsState}		
               editState={emptwin}			
              formType={fileTypes}			
              documentFolderName = "employeetwin"			
   	      softSkillDoc='softSkillDocState'		
              sopInvalid={sopInvalid}		
              setSopInvalid={setSopInvalid} 	
              name="etedit"        			
  	    />			
          ) : null}			
        </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  //console.log("state", state);

  return {
    session: state.session.session,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    sessionTimeOutCheck: bindActionCreators(sessionTimeOutCheck, dispatch),
    checkExpiry: bindActionCreators(checkExpiry, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(index);
